import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ShiftConfigWithBreaksForm } from 'modules/shift_management/components/Settings/ShiftTemplates/Content/EditTemplateWeek/WeekSettings/WeekConfiguration/forms'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

import BreakDetails from './BreakDetails'
import BreakInputs from './BreakInputs'
import BreakWarning from './BreakWarning'

interface Props {
  form: ShiftConfigWithBreaksForm
  breakForm: PlannedBreakForm
  onDeleteBreak: (dayConfig: ShiftConfigWithBreaksForm, form: PlannedBreakForm) => void
}

const BreakDisplay = ({ form, breakForm, onDeleteBreak }: Props) => {
  const { shiftConfig } = form
  const { formattedStartAt: startAt, formattedEndAt: endAt } = shiftConfig

  return (
    <Box gap="s8">
      <Box
        borderRadius={{
          all: 'abs008',
        }}
        padding="s16"
        background="grey100"
        gap="s16"
      >
        {breakForm.isArchived ? (
          <BreakWarning onDeleteBreak={() => onDeleteBreak(form, breakForm)} />
        ) : (
          <>
            <BreakDetails shiftConfig={form} onDeleteBreak={onDeleteBreak} form={breakForm} />
            <BreakInputs form={breakForm} validationParams={{ startAt, endAt }} />
          </>
        )}
      </Box>
    </Box>
  )
}

export default observer(BreakDisplay)
